import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { initAuthSessionQuerySync } from 'services/authSession/syncQueryCache';

const AuthSessionSync = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    initAuthSessionQuerySync(queryClient);
  }, [queryClient]);

  return null;
};

export default AuthSessionSync;
